import axios from "axios";
//GET ALL CARCATAGORY BY COUNTRY
export const CUSTOMER_CANCEL_CHEQUE = "CUSTOMER_CANCEL_CHEQUE";
export const CUSTOMER_CANCEL_CHEQUE_LOADING =
"CUSTOMER_CANCEL_CHEQUE_LOADING";
export const CUSTOMER_CANCEL_CHEQUE_LOADING_FAILED =
"CUSTOMER_CANCEL_CHEQUE_LOADING_FAILED";

// HELPER ACTIONS CREATORS
//************************************** /

export const cancelChequeLoading = ms => ({
    type: CUSTOMER_CANCEL_CHEQUE_LOADING,
    payload: ms
    });
    
    export const cancelChequeLoadingFailed = ms => ({
    type: CUSTOMER_CANCEL_CHEQUE_LOADING_FAILED,
    payload: ms
    });

// RIDER PHINE NUBER
export function cancelCheque(obj) {
        const request = axios.post(
            `${process.env.REACT_APP_FILE}/accountRoutes/api/v1/cheque/chequeCancel`, obj,{
                headers: { 'Authorization': 'bearer ' +localStorage.accountantToken}
              });
    
    
    return dispatch => {

    dispatch(cancelChequeLoading());
    request
    .then(response => {   
  
    if (response.status == 200 || response.status == 201) {
   /*   console.log(response,"response cancelCheque") */
    dispatch({
    type: CUSTOMER_CANCEL_CHEQUE,
    payload: response.data
    });
  
    } else {
      
    throw new Error(JSON.stringify(response.data.response.msg));
    }
    })
    .catch(error => {
        
    if (error.response) {
    if (error.response.status == "404") {
        console.log(error.response)
    dispatch(
        cancelChequeLoadingFailed(error.response.data.message)
    );
    } else {
    dispatch(cancelChequeLoadingFailed(error.response.data.message));
    }
    console.log(error.response.data);
    console.log(error.response.status);
    console.log(error.response.headers);
    } else if (error.request) {
    /*
    * The request was made but no response was received, `error.request`
    * is an instance of XMLHttpRequest in the browser and an instance
    * of http.ClientRequest in Node.js
    */
    dispatch(cancelChequeLoadingFailed(error.request));
    
    console.log(error.request);
    } else {
    // Something happened in setting up the request and triggered an Error
    console.log("Error", error.message);
    dispatch(cancelChequeLoadingFailed(error.message));
    }
    console.log(error);
    });
    };
    }


